<!--
  ~ Copyright 2026 NXGN Management, LLC. All Rights Reserved.
  -->

<div
  id="confirmation-dialog"
  class="modal-content border-0"
  role="dialog"
  aria-modal="true"
  aria-labelledby="confirmation-dialog-title"
  aria-describedby="confirmation-dialog-message"
  cdkTrapFocus
  [cdkTrapFocusAutoCapture]="true"
  (keydown.escape)="cancel()"
>
  <div id="confirmation-dialog-header" class="modal-header">
    <h2 id="confirmation-dialog-title" class="modal-title">
      {{ dialogData.title }}
    </h2>
    <button
      id="confirmation-dialog-close-btn"
      type="button"
      class="close confirmation-dialog-close-btn"
      aria-label="Close dialog"
      (click)="cancel()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div id="confirmation-dialog-body" class="modal-body">
    <p id="confirmation-dialog-message">{{ dialogData.message }}</p>
    <table
      id="confirmation-dialog-table"
      class="confirmation-dialog-table"
      *ngIf="dialogData.tableHeaders?.length && dialogData.tableRows?.length"
      aria-label="Affected items"
    >
      <thead>
        <tr>
          <th *ngFor="let header of dialogData.tableHeaders" scope="col">
            {{ header }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          *ngFor="let row of dialogData.tableRows; let i = index"
          [attr.id]="'confirmation-dialog-table-row-' + i"
        >
          <td *ngFor="let cell of row">{{ cell }}</td>
        </tr>
      </tbody>
    </table>
    <p *ngIf="dialogData.postMessage" class="confirmation-dialog-post-message">
      {{ dialogData.postMessage }}
    </p>
    <ul
      id="confirmation-dialog-list"
      class="confirmation-dialog-list"
      *ngIf="
        !(dialogData.tableHeaders?.length && dialogData.tableRows?.length) &&
        dialogData.listItems?.length
      "
      role="list"
      aria-label="Affected items"
    >
      <li
        *ngFor="let item of dialogData.listItems; let i = index"
        [attr.id]="'confirmation-dialog-list-item-' + i"
        role="listitem"
      >
        {{ item }}
      </li>
    </ul>
  </div>
  <div id="confirmation-dialog-footer" class="modal-footer">
    <button
      id="confirmation-dialog-cancel-btn"
      type="button"
      (click)="cancel()"
      class="btn btn-light confirmation-dialog-btn"
      cdkFocusInitial
      *ngIf="dialogData.showCancelButton !== false"
      [attr.aria-label]="dialogData.cancelButtonText"
    >
      <span class="oi oi-x" aria-hidden="true"></span>
      {{ dialogData.cancelButtonText }}
    </button>
    <button
      id="confirmation-dialog-confirm-btn"
      type="button"
      (click)="confirm()"
      class="btn btn-primary confirmation-dialog-btn"
      *ngIf="dialogData.showConfirmButton !== false"
      [attr.aria-label]="dialogData.confirmButtonText"
    >
      <span aria-hidden="true">
        <fa-icon [icon]="faCheck"></fa-icon>
      </span>
      {{ dialogData.confirmButtonText }}
    </button>
  </div>
</div>
